import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>&copy; {currentYear} City Eisteddfod</p>
    </footer>
  );
}

export default Footer;
